export const DEFAULT_CATEGORIES = [
  "Accessories",
  "Alterations",
  "Attire - Custom",
  "Cake & Desserts",
  "Caterer",
  "Celebrant / Officiant",
  "Content Creator",
  "Dance Classes",
  "DJ",
  "Dress Boutique",
  "Dress Designer",
  "Engagement Rings",
  "Entertainment",
  "Florist",
  "Hair",
  "Hair & Makeup",
  "Lighting",
  "Live Music",
  "Makeup",
  "Miscellaneous",
  "Photobooth",
  "Photographer",
  "Planner",
  "Rental / Decor",
  "Shoes",
  "Signage",
  "Stationery",
  "Stylist",
  "Suit / Menswear",
  "Transport",
  "Venue",
  "Videographer",
  "Wedding Rings",
];

export const PREFERRED_TERMS = [
  "Beeb", "Beloved", "Betrothed", "Bride", "Bridegroom", "Broom",
  "Celebrant", "Gride", "Groom", "Hersband", "Just your name",
  "Lady Husband", "Lady Love", "Lifer", "Lover", "Marrier", "My person",
  "Nife", "Partner", "Partner in Marriage", "Promised One", "Spouse",
  "Sweet", "Wed", "Wedded Partner", "Wedfolx", "Wifeband", "Wubby",
];
